import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import { Link } from "react-router-dom";

import '../../../assets/style/HPC4.css';

import aiic1 from "../../../assets/icon/aiic1.svg";
import aiic2 from "../../../assets/icon/aiic2.svg";
import aiic3 from "../../../assets/icon/aiic3.svg";
import aiic4 from "../../../assets/icon/aiic4.svg";
import aiic5 from "../../../assets/icon/aiic5.svg";
import aiic6 from "../../../assets/icon/aiic6.svg";
import aiic7 from "../../../assets/icon/aiic7.svg";
import { useTranslation } from "react-i18next";

function HPC4(params) {
    const { t } = useTranslation();


    const listCapability = [
    {
        tag: "Language",
        title: "Question Answer",
        text: t("hpc4product8"),
        icon: aiic1,
        link: "/qa"
    },
    {
        tag: "Language",
        title: "News",
        text: t("hpc4product9"),
        icon: aiic1,
        link: "/news"
    },
    {
        tag: "Language",
        title: "Fewshot",
        text: t("hpc4product10"),
        icon: aiic1,
        link: "/fewshot"
    },
    // {
    //     tag: "Language",
    //     title: "Natural Language Processing",
    //     text: t("hpc4product1"),
    //     icon: aiic1,
    //     link: "/nlp"
    // },
    {
        tag: "Voice",
        title: "Voice Cloning",
        text: t("hpc4product2"),
        icon: aiic2,
        link: "/voice-cloning"
    },
    {
        tag: "Voice",
        title: "Voice Separation",
        text: t("hpc4product3"),
        icon: aiic3,
        link: "/voice-separation"
    },
    {
        tag: "Image",
        title: "Custom Image Classification",
        text: t("hpc4product4"),
        icon: aiic4,
        link: "/custom-image-classification"
    },
    {
        tag: "Image",
        title: "Image Similarity",
        text: t("hpc4product5"),
        icon: aiic5,
        link: "/custom-image-similarity"
    },
    {
        tag: "Image",
        title: "Optical Character Recognition",
        text: t("hpc4product6"),
        icon: aiic6,
        link: "/ocr"
    },
    {
        tag: "Design",
        title: "3D",
        text: t("hpc4product7"),
        icon: aiic7,
        link: "/3d-motion"
    }];

    return(
        <section className="HCP4">
            <h2 className='white'>{t("hpc4title")}</h2>
        
            <div className="listCardHCP4">
                <Carousel
                    additionalTransfrom={0}
                    arrows={true}
                    autoPlay={true}
                    autoPlaySpeed={4000}
                    centerMode={false}
                    className=""
                    customTransition="all 1s linear"
                    containerClass="container-with-dots"
                    dotListClass=""
                    draggable
                    focusOnSelect={false}
                    infinite
                    itemClass=""
                    keyBoardControl
                    minimumTouchDrag={80}
                    pauseOnHover={true}
                    renderArrowsWhenDisabled={false}
                    renderButtonGroupOutside={false}
                    renderDotsOutside={false}
                    responsive={{
                        desktop: {
                        breakpoint: {
                            max: 3000,
                            min: 1024
                        },
                        items: 3,
                        partialVisibilityGutter: 40
                        },
                        mobile: {
                        breakpoint: {
                            max: 464,
                            min: 0
                        },
                        items: 1,
                        partialVisibilityGutter: 30
                        },
                        tablet: {
                        breakpoint: {
                            max: 1024,
                            min: 464
                        },
                        items: 2,
                        partialVisibilityGutter: 30
                        }
                    }}
                    rewind={false}
                    rewindWithAnimation={false}
                    rtl={false}
                    shouldResetAutoplay
                    showDots={false}
                    sliderClass=""
                    slidesToSlide={1}
                    swipeable={true}
                    // transitionDuration={1000}
                >
                    {listCapability.map((item, index) => (
                        <div key={index} className="cardAIHCP4"> 
                            <div>
                                <div className="tagCardHCP4">{item.tag}</div>
                                <p className="titleCardHCP4">{item.title}</p>
                                <p className="textCardHCP4">{item.text}</p>
                            </div>

                            <div className="mb24">
                                <hr/>
                                <div className="bottomCardHCP4">
                                    <img src={item.icon} alt="icon"></img>
                                    <Link 
                                    className="buttonSubmit" 
                                    onClick={() => {
                                        window.scrollTo({
                                            top: document.body.scrollHeight,
                                            behavior: "smooth"
                                        }) 
                                    }} >{t("contactus")}</Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </Carousel>
            </div>
        </section>
    );
};

export default HPC4;